import axios, {
  AxiosInstance,
  AxiosError,
  InternalAxiosRequestConfig,
} from "axios";
import {
  REACT_APP_API_BASE_URL,
  REACT_APP_NODE_API_BASE_URL,
} from "./environment";
// Laravel instance
const axiosInstance: AxiosInstance = axios.create({
  baseURL: REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
// Node.js instance
export const nodeAxiosInstance: AxiosInstance = axios.create({
  baseURL: REACT_APP_NODE_API_BASE_URL,
  // headers: {
  //   "Content-Type": "application/json",
  // },
});
// Shared Request Interceptor
const attachToken = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const token = localStorage.getItem("token");
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};
// Shared Response Interceptor
const handleAuthError = (error: AxiosError) => {
  if (error.response && error.response.status === 401) {
    console.warn("Unauthorized - clearing local storage and redirecting...");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("tokenExpirationTime");
    window.location.href = "/";
  }
  return Promise.reject(error);
};
// Apply interceptors to both instances
axiosInstance.interceptors.request.use(attachToken, Promise.reject);
axiosInstance.interceptors.response.use(res => res, handleAuthError);
nodeAxiosInstance.interceptors.request.use(attachToken, Promise.reject);
nodeAxiosInstance.interceptors.response.use(res => res, handleAuthError);
// Export default Laravel instance
export default axiosInstance;